module.exports = __webpack_public_path__ + "static/hifi6-623f2847caa51fcbc567b89543723dfc.jpg";